import React from 'react';
import { useDispatch, history, getLocale } from 'umi';
import { useMount } from 'ahooks';
import classPrefix from 'prefix-classnames';
import { getLoginUserInfo } from '@/services/UserApi';
import { zhHant } from '@gov-mo/components/esm/locales/pc';
import { ConfigProvider } from 'antd';
import { getLocale2ComponentLocaleMap } from '@/locales/lang';
import { updateLocale } from '@/utils/languageUtils';
import './WebLayout.less';

const px = classPrefix('web-layout');

const WebLayout = function ({ children }) {
  const dispatch = useDispatch();
  const {
    location: { query = {}},
  } = history;
  const { language } = query as Record<string, string>;


  useMount(() => {
    updateLocale(language);
    getLoginUserInfo().then((res) => {
      console.log("🚀 ~ getLoginUserInfo ~ res:", res.data)
      dispatch({ type: 'user/update', profile: res.data });
    });
  });

  const defaultAntdLocale = {
    ...(require('@gov-mo/components/esm/locales/pc')[getLocale2ComponentLocaleMap[getLocale()]] ??
      zhHant),
  };

  return (
    <ConfigProvider locale={defaultAntdLocale}>
      <div className={px('root')}>
        <div className={px('content')} style={{ position: 'relative' }}>
          {children}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default WebLayout;
